import createAlgoliaRecommendationsEngine, {
  ALGOLIA_BOUGHT_TOGETHER,
  ALGOLIA_RELATED,
  ALGOLIA_TRENDING,
} from './AlgoliaRecommendations';
import createShopifyRecommendationsEngine, {
  SHOPIFY_COMPLEMENTARY,
  SHOPIFY_RELATED,
} from './ShopifyRecommendations';

const createPhillRecommendations = ({
  sectionId,
  compilationTemplate, // Used for transforming Algolia results into HTML
  limit = 10,
  itemQuery = null,
  retrievableAttributes = ['handle'],
}) => {
  const algoliaRecommendationsEngine = createAlgoliaRecommendationsEngine({
    compilationTemplate,
    retrievableAttributes,
    itemQuery,
    limit,
  });

  const shopifyRecommendationsEngine = createShopifyRecommendationsEngine({
    sectionId,
    itemQuery,
    limit,
  });

  const getRecommendationEngine = (type) => {
    const useShopify = [SHOPIFY_COMPLEMENTARY, SHOPIFY_RELATED].includes(type);
    const useAlgolia = [ALGOLIA_TRENDING, ALGOLIA_RELATED, ALGOLIA_BOUGHT_TOGETHER].includes(type);

    if (useAlgolia) return algoliaRecommendationsEngine;
    if (useShopify) return shopifyRecommendationsEngine;

    return null;
  };

  const query = async (...queries) => {
    const promises = queries.map(([recommendationType, items = []]) => {
      const engine = getRecommendationEngine(recommendationType);

      if (engine) return engine.query(recommendationType, items);

      // Recommendation type isn't supported
      return Promise.resolve(null);
    });

    try {
      const results = await Promise.all(promises);
      return results;
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      return [];
    }
  };

  return [query];
};

export default class {
  constructor(...args) {
    [this.query] = createPhillRecommendations(...args);
  }
}
